import { render } from "./AnnotationToolRibbon.vue?vue&type=template&id=4cbc94aa&scoped=true"
import script from "./AnnotationToolRibbon.vue?vue&type=script&lang=js"
export * from "./AnnotationToolRibbon.vue?vue&type=script&lang=js"

import "./AnnotationToolRibbon.vue?vue&type=style&index=0&id=4cbc94aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbc94aa"]])

export default __exports__